module.exports = __webpack_public_path__ + "img/video-player/play-white-f66e238462617334c1b110617eb3985b.svg";